module.exports = __webpack_public_path__ + "img/zep1.b48cf905.jpg";